import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class PingPong extends ModelPrototype {
  public async ping(): Promise<any> {
    try {
      return this.withUrl(`main/ping`).setMethod(Method.POST).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
